module.exports = __webpack_public_path__ + "media/images/icons/flags/TV-02f35157e88503fc803ffd4dd8b5301c.svg";